(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "6dPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(JSON.parse(s.responseText))},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null)})});
//# sourceMappingURL=unfetch.mjs.map


/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BtxX":
/***/ (function(module, exports) {

(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(this);

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "FO8O":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("mX86");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.module.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!../../../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./style.module.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/preact-habitat/dist/preact-habitat.es.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Removes `-` fron a string and capetalize the letter after
 * example: data-props-hello-world =>  dataPropsHelloWorld
 * Used for props passed from host DOM element
 * @param  {String} str string
 * @return {String} Capetalized string
 */
var camelcasize = function camelcasize(str) {
  return str.replace(/-([a-z])/gi, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * [getExecutedScript internal widget to provide the currently executed script]
 * @param  {document} document [Browser document object]
 * @return {HTMLElement}     [script Element]
 */
var getExecutedScript = function getExecutedScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  }();
};

/**
 * Get the props from a host element's data attributes
 * @param  {Element} tag The host element
 * @return {Object}  props object to be passed to the component
 */
var collectPropsFromElement = function collectPropsFromElement(element, defaultProps) {
  if (defaultProps === void 0) defaultProps = {};

  var attrs = element.attributes;

  var props = _extends({}, defaultProps);

  // collect from element
  Object.keys(attrs).forEach(function (key) {
    if (attrs.hasOwnProperty(key)) {
      var dataAttrName = attrs[key].name;
      if (!dataAttrName || typeof dataAttrName !== "string") {
        return false;
      }
      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
      propName = camelcasize(propName);
      if (dataAttrName !== propName) {
        var propValue = attrs[key].nodeValue;
        props[propName] = propValue;
      }
    }
  });

  // check for child script text/props or application/json
  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
    var propsObj = {};
    if (scrp.hasAttribute('type')) {
      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") {
        return;
      }
      try {
        propsObj = JSON.parse(scrp.innerHTML);
      } catch (e) {
        throw new Error(e);
      }
      _extends(props, propsObj);
    }
  });

  return props;
};

var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript) {
  var scriptTagAttrs = currentScript.attributes;
  var selector = null;
  // check for another props attached to the tag
  Object.keys(scriptTagAttrs).forEach(function (key) {
    if (scriptTagAttrs.hasOwnProperty(key)) {
      var dataAttrName = scriptTagAttrs[key].name;
      if (dataAttrName === 'data-mount-in') {
        selector = scriptTagAttrs[key].nodeValue;
      }
    }
  });
  return selector;
};

/**
 * Return array of 0 or more elements that will host our widget
 * @param  {id} attrId the data widget id attribute the host should have
 * @param  {document} scope  Docuemnt object or DOM Element as a scope
 * @return {Array}        Array of matching habitats
 */
var widgetDOMHostElements = function widgetDOMHostElements(ref) {
  var selector = ref.selector;
  var inline = ref.inline;
  var clientSpecified = ref.clientSpecified;

  var hostNodes = [];
  var currentScript = getExecutedScript();

  if (inline === true) {
    var parentNode = currentScript.parentNode;
    hostNodes.push(parentNode);
  }
  if (clientSpecified === true && !selector) {
    // user did not specify where to mount - get it from script tag attributes
    selector = getHabitatSelectorFromClient(currentScript);
  }
  if (selector) {
    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
      hostNodes.push(queriedTag);
    });
  }
  return hostNodes;
};

/**
 * preact render function that will be queued if the DOM is not ready
 * and executed immeidatly if DOM is ready
 */
var preact_habitat_es_preactRender = function preactRender(widget, hostElements, root, cleanRoot, defaultProps) {
  hostElements.forEach(function (elm) {
    var hostNode = elm;
    if (hostNode._habitat) {
      return;
    }
    hostNode._habitat = true;
    var props = collectPropsFromElement(elm, defaultProps) || defaultProps;
    if (cleanRoot) {
      hostNode.innerHTML = "";
    }
    return Object(preact_min["render"])(Object(preact_min["h"])(widget, props), hostNode, root);
  });
};

var habitat = function habitat(Widget) {
  // Widget represents the Preact component we need to mount
  var widget = Widget;
  // preact root render helper
  var root = null;

  var render$$1 = function render$$1(ref) {
    if (ref === void 0) ref = {};
    var selector = ref.selector;if (selector === void 0) selector = null;
    var inline = ref.inline;if (inline === void 0) inline = false;
    var clean = ref.clean;if (clean === void 0) clean = false;
    var clientSpecified = ref.clientSpecified;if (clientSpecified === void 0) clientSpecified = false;
    var defaultProps = ref.defaultProps;if (defaultProps === void 0) defaultProps = {};

    var elements = widgetDOMHostElements({
      selector: selector,
      inline: inline,
      clientSpecified: clientSpecified
    });
    var loaded = function loaded() {
      if (elements.length > 0) {
        var elements$1 = widgetDOMHostElements({
          selector: selector,
          inline: inline,
          clientSpecified: clientSpecified
        });

        return preact_habitat_es_preactRender(widget, elements$1, root, clean, defaultProps);
      }
    };
    loaded();
    document.addEventListener("DOMContentLoaded", loaded);
    document.addEventListener("load", loaded);
  };

  return { render: render$$1 };
};

/* harmony default export */ var preact_habitat_es = (habitat);
//# sourceMappingURL=preact-habitat.es.js.map
// EXTERNAL MODULE: ./components/translate-box/style.module.scss
var style_module = __webpack_require__("FO8O");
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);

// CONCATENATED MODULE: ./components/icon/RightIcon.js


var _ref2 = Object(preact_min["h"])(
  "g",
  null,
  Object(preact_min["h"])(
    "g",
    null,
    Object(preact_min["h"])("path", {
      d: "M386.235,248.308L140.902,2.975c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76 l-237.76,237.867c-4.267,4.053-4.373,10.88-0.213,15.04c4.053,4.267,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213 l245.333-245.333C390.395,259.188,390.395,252.468,386.235,248.308z"
    })
  )
);

var _ref3 = Object(preact_min["h"])("g", null);

var _ref4 = Object(preact_min["h"])("g", null);

var _ref5 = Object(preact_min["h"])("g", null);

var _ref6 = Object(preact_min["h"])("g", null);

var _ref7 = Object(preact_min["h"])("g", null);

var _ref8 = Object(preact_min["h"])("g", null);

var _ref9 = Object(preact_min["h"])("g", null);

var _ref10 = Object(preact_min["h"])("g", null);

var _ref11 = Object(preact_min["h"])("g", null);

var _ref12 = Object(preact_min["h"])("g", null);

var _ref13 = Object(preact_min["h"])("g", null);

var _ref14 = Object(preact_min["h"])("g", null);

var _ref15 = Object(preact_min["h"])("g", null);

var _ref16 = Object(preact_min["h"])("g", null);

var _ref17 = Object(preact_min["h"])("g", null);

/* harmony default export */ var RightIcon = (function (_ref) {
  var className = _ref.className;

  return Object(preact_min["h"])(
    "svg",
    {
      "class": className,
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "15px",
      height: "15px",
      viewBox: "0 0 511.949 511.949"
    },
    _ref2,
    _ref3,
    _ref4,
    _ref5,
    _ref6,
    _ref7,
    _ref8,
    _ref9,
    _ref10,
    _ref11,
    _ref12,
    _ref13,
    _ref14,
    _ref15,
    _ref16,
    _ref17
  );
});
// CONCATENATED MODULE: ./components/icon/ClearIcon.js


var ClearIcon__ref2 = Object(preact_min["h"])(
  "g",
  null,
  Object(preact_min["h"])(
    "g",
    null,
    Object(preact_min["h"])("path", {
      d: "M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0   C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778   c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828   c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828   l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z",
      "data-original": "#000000",
      className: "active-path",
      "data-old_color": "#000000"
    })
  )
);

/* harmony default export */ var ClearIcon = (function (_ref) {
  var className = _ref.className;

  return Object(preact_min["h"])(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 51.976 51.976",
      xmlSpace: "preserve",
      width: "15px",
      height: "15px",
      className: className
    },
    ClearIcon__ref2,
    ' '
  );
});
// CONCATENATED MODULE: ./components/icon/SubmitIcon.js


var SubmitIcon__ref2 = Object(preact_min["h"])("path", { d: "m250.734 40.137-90.265-.02v20.059h90.265c5.534 0 10.029 4.515 10.029 10.049v80.216c0 5.534-4.496 10.029-10.029 10.029h-212.34l45.877-45.877-14.182-14.182-70.089 70.088 70.206 70.206 14.182-14.182-45.994-45.994h212.341c16.592 0 30.088-13.497 30.088-30.088v-80.216c0-16.592-13.497-30.088-30.089-30.088z" });

/* harmony default export */ var SubmitIcon = (function (_ref) {
  var className = _ref.className;

  return Object(preact_min["h"])(
    "svg",
    {
      "class": className,
      id: "Capa_1",
      "enable-background": "new 0 0 280.823 280.823",
      viewBox: "0 0 280.823 280.823",
      xmlns: "http://www.w3.org/2000/svg",
      width: "15px",
      height: "15px"
    },
    SubmitIcon__ref2
  );
});
// EXTERNAL MODULE: ../node_modules/isomorphic-unfetch/browser.js
var browser = __webpack_require__("VS7n");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./utils/apiCalls.js


var BASE_URI = "https://www.wordyguru.com/api/v1";
var PROXY_URI = BASE_URI;

//translation
var postTranslate = function postTranslate(from, to, message) {
  var $args = arguments;return new Promise(function ($return, $error) {
    var proxy, url, obj, res, json;
    proxy = $args.length > 3 && $args[3] !== undefined ? $args[3] : false;

    url = (!proxy ? BASE_URI : PROXY_URI) + "/translation/translate";
    obj = { from: from, to: to, message: message };
    return Promise.resolve(fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json"
      },
      body: JSON.stringify(obj)
    })).then(function ($await_1) {
      try {
        res = $await_1;

        return Promise.resolve(res.json()).then(function ($await_2) {
          try {
            json = $await_2;
            return $return(json);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};
// CONCATENATED MODULE: ./components/translate-box/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import SectionTitle from '../base/SectionTitle';
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import ButterToast, { Cinnamon, POS_TOP, POS_CENTER } from 'butter-toast';



var groupBy = function groupBy(xs, f) {
  //return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  return xs.reduce(function (r, v, i, a) {
    var k = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : f(v) === "constructor" ? f(v) + "." : f(v);
    return (r[k] || (r[k] = [])).push(v), r;
  }, {});
};

var process = {
  env: { URL: "https://www.wordyguru.com" }
};

var translate_box__ref = Object(preact_min["h"])(RightIcon, null);

var translate_box__ref2 = Object(preact_min["h"])(RightIcon, null);

var translate_box__ref3 = Object(preact_min["h"])("br", null);

var translate_box__ref4 = Object(preact_min["h"])(ClearIcon, null);

var translate_box__ref5 = Object(preact_min["h"])(SubmitIcon, null);

var translate_box_TranslateBox = function (_Component) {
  _inherits(TranslateBox, _Component);

  function TranslateBox(props) {
    _classCallCheck(this, TranslateBox);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (event) {
      var text = event.target.value;
      _this.setState({ text: text });
      var from = "";
      var to = "";
      if (event.target.value !== "") {
        from = "en";
        to = "th";
        var thai = "[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ]+";
        //var english = /[^A-Za-z0-9\.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*$/;
        var patt = new RegExp(thai, "g");
        if (patt.test(text)) {
          from = "th";
          to = "en";
        }
      }
      _this.setState({ from: from, to: to });
    };

    _this.handleSubmit = function (event) {
      return new Promise(function ($return, $error) {
        var _this$state, from, to, text, res, groupRelated, resultRelateds, tmp;

        if (!_this.state.text) {
          return $return();
        }
        if (event) {
          event.preventDefault();
        }

        _this$state = _this.state, from = _this$state.from, to = _this$state.to, text = _this$state.text;


        _this.setState({
          isTranslated: true,
          translateText: "",
          resultRelateds: {}
        });

        return Promise.resolve(postTranslate(from, to, text, true)).then(function ($await_1) {
          try {
            res = $await_1;
            if (res.status && res.status !== 200) {
              res.result = "";
            }

            groupRelated = {};
            if (res && res.relateds) {
              resultRelateds = groupBy(res.relateds, function (c) {
                return c.app_id;
              });
              for (var key in resultRelateds) {
                if (resultRelateds.hasOwnProperty(key)) {
                  if (key === 27) {
                    tmp = groupBy(resultRelateds[key], function (c) {
                      return c.line_three;
                    });
                    groupRelated[key] = tmp;
                  } else {
                    tmp = groupBy(resultRelateds[key], function (c) {
                      return c.line_one;
                    });
                    groupRelated[key] = tmp;
                  }
                }
              }
            }

            _this.setState({
              translateText: res.result ? res.result : "",
              resultRelateds: groupRelated
            }, function () {
              var that = _this;
              setTimeout(function () {
                that.translate.focus();
              }, 100);
            });
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };

    _this.createTable = function (wordGroup) {
      var list = [];
      Object.keys(wordGroup).map(function (key) {
        //find top word of group
        var index = 0;
        var l3Key = Object.keys(wordGroup[key])[0];
        var word = wordGroup[key][l3Key][0];
        list.push(Object(preact_min["h"])(
          "tr",
          { key: "trtt" + key },
          Object(preact_min["h"])(
            "td",
            { colSpan: "3", "class": style_module_default.a.nobd },
            Object(preact_min["h"])(
              "h3",
              null,
              key === "27" ? "\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E2D\u0E07 " + word.line_one : word.app_name
            )
          )
        ));
        Object.keys(wordGroup[key]).map(function (inkey) {
          inkey !== "null" && list.push(Object(preact_min["h"])(
            "tr",
            { key: "trl3" + key + inkey },
            Object(preact_min["h"])(
              "td",
              { colSpan: "3", "class": style_module_default.a["category"] },
              Object(preact_min["h"])(
                "h4",
                { "class": "sub-title is-uppercase is-size-7" },
                inkey
              )
            )
          ));
          wordGroup[key][inkey].map(function (word) {
            if (key !== "27") {
              list.push(Object(preact_min["h"])(
                "tr",
                { key: "trl1" + word.id },
                Object(preact_min["h"])(
                  "td",
                  { "class": style_module_default.a["text-grey"] },
                  Object(preact_min["h"])(
                    "p",
                    null,
                    ++index
                  )
                ),
                Object(preact_min["h"])(
                  "td",
                  null,
                  Object(preact_min["h"])(
                    "div",
                    null,
                    Object(preact_min["h"])(
                      "p",
                      { "class": "is-capitalized is-size-6" },
                      word.line_one
                    ),
                    word.line_two && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_two
                    ),
                    word.line_three && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_three
                    ),
                    word.line_four && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_four
                    ),
                    word.line_five && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_five
                    ),
                    word.note && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.note
                    )
                  )
                ),
                Object(preact_min["h"])(
                  "td",
                  null,
                  Object(preact_min["h"])(
                    "a",
                    {
                      target: "_blank",
                      rel: "nofollow",
                      href: process.env.URL + "/a/" + word.app_slug + "/q/" + word.slug,
                      "class": "link"
                    },
                    translate_box__ref
                  )
                )
              ));
            } else {
              list.push(Object(preact_min["h"])(
                "tr",
                { key: "trl1" + word.id },
                Object(preact_min["h"])(
                  "td",
                  { "class": style_module_default.a["text-grey"] },
                  Object(preact_min["h"])(
                    "p",
                    null,
                    ++index
                  )
                ),
                Object(preact_min["h"])(
                  "td",
                  null,
                  Object(preact_min["h"])(
                    "div",
                    null,
                    word.line_two && Object(preact_min["h"])(
                      "p",
                      { "class": "is-capitalized is-size-6" },
                      word.line_two
                    ),
                    word.line_four && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_four
                    ),
                    word.line_five && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.line_five
                    ),
                    word.note && Object(preact_min["h"])(
                      "p",
                      { "class": style_module_default.a["text-grey"] },
                      word.note
                    )
                  )
                ),
                Object(preact_min["h"])(
                  "td",
                  null,
                  Object(preact_min["h"])(
                    "a",
                    {
                      target: "_blank",
                      rel: "nofollow",
                      href: process.env.URL + "/a/" + word.app_slug + "/q/" + word.slug,
                      "class": "link"
                    },
                    translate_box__ref2
                  )
                )
              ));
            }
          });
        });
        list.push(Object(preact_min["h"])(
          "tr",
          { key: "trtb" + key },
          Object(preact_min["h"])("td", { "class": style_module_default.a["nobd"] }),
          Object(preact_min["h"])(
            "td",
            { "class": style_module_default.a["nobd"], colspan: "2" },
            translate_box__ref3
          )
        ));
      });

      return list;
    };

    _this.state = {
      text: "",
      translateText: "",
      lang: props.lang ? props.lang : "th",
      isTranslated: false,
      resultRelateds: [],
      from: "",
      to: ""
    };

    _this.translate = [];
    return _this;
  }

  TranslateBox.prototype.onCopyClick = function onCopyClick(text, title, content) {
    if (text) {
      // ButterToast.raise({
      //   content: (
      //     <Cinnamon.Crisp
      //       scheme={Cinnamon.Crisp.SCHEME_GREY}
      //       content={content}
      //       title={title}
      //     />
      //   )
      // });
    }
  };

  TranslateBox.prototype.render = function render(props, state) {
    var _this2 = this;

    return Object(preact_min["h"])(
      "div",
      { "class": "" },
      Object(preact_min["h"])(
        "div",
        { "class": style_module_default.a["main-translate-box"] },
        Object(preact_min["h"])(
          "div",
          { "class": style_module_default.a["translate-box"] },
          Object(preact_min["h"])(
            "div",
            { "class": style_module_default.a["translate-box__input-box"] },
            Object(preact_min["h"])(
              "div",
              { "class": style_module_default.a["translate-box__input"] },
              Object(preact_min["h"])(
                "p",
                { "class": style_module_default.a["translate-box__lang"] },
                state.from === "" ? "\u0E20\u0E32\u0E29\u0E32\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07" : state.from === "th" ? "ภาษาไทย" : "English",
                Object(preact_min["h"])(
                  "span",
                  null,
                  state.from === "" ? "\u0E15\u0E23\u0E27\u0E08\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34" : state.from === "en" ? "ภาษาไทย" : "English"
                )
              ),
              Object(preact_min["h"])("textarea", {
                "class": style_module_default.a["source"],
                placeholder: state.lang === "th" ? "พิมพ์ ภาษาไทย หรือ ภาษาอังกฤษ หรือกดปุ่มวางข้อความ แล้วกดปุ่มเพื่อทำการแปล" : "Type a text or paste text here to translate",
                onInput: function onInput(e) {
                  return _this2.handleChange(e);
                },
                value: state.text
              }),
              state.text.length > 0 && Object(preact_min["h"])(
                "button",
                {
                  "class": style_module_default.a["clear"],
                  onClick: function onClick() {
                    return _this2.setState({ text: "", translateText: "" });
                  }
                },
                translate_box__ref4
              ),
              Object(preact_min["h"])(
                "button",
                {
                  "class": state.text.length > 0 ? style_module_default.a["active"] : "",
                  onClick: function onClick(e) {
                    return _this2.handleSubmit(e);
                  }
                },
                translate_box__ref5
              )
            ),
            Object(preact_min["h"])(
              "div",
              { "class": style_module_default.a["translate-box__panel"] },
              Object(preact_min["h"])("ul", null)
            )
          )
        ),
        Object(preact_min["h"])(
          "div",
          { "class": style_module_default.a["translate-box"] },
          Object(preact_min["h"])(
            "div",
            { "class": style_module_default.a["translate-box__input-box"] },
            Object(preact_min["h"])(
              "div",
              { "class": style_module_default.a["translate-box__input"] },
              Object(preact_min["h"])(
                "p",
                { "class": style_module_default.a["translate-box__lang"] },
                state.to === "" ? "\u0E04\u0E33\u0E41\u0E1B\u0E25" : state.to === "th" ? "ภาษาไทย" : "English",
                Object(preact_min["h"])(
                  "span",
                  null,
                  state.to === "" ? "\u0E15\u0E23\u0E27\u0E08\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34" : state.to === "en" ? "ภาษาไทย" : "English"
                )
              ),
              Object(preact_min["h"])("textarea", {
                ref: function ref(ele) {
                  return _this2.translate = ele;
                },
                value: state.translateText,
                readOnly: true,
                placeholder: state.text && state.text.length > 0 ? "..." : ""
              })
            ),
            Object(preact_min["h"])(
              "div",
              { "class": style_module_default.a["translate-box__panel"] },
              Object(preact_min["h"])("ul", null)
            )
          )
        )
      ),
      Object.keys(state.resultRelateds).length > 0 && Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "div",
          { "class": style_module_default.a["related-result"] },
          Object(preact_min["h"])(
            "table",
            null,
            Object(preact_min["h"])(
              "tbody",
              null,
              this.createTable(state.resultRelateds)
            )
          )
        )
      )
    );
  };

  return TranslateBox;
}(preact_min["Component"]);

/* harmony default export */ var translate_box = (translate_box_TranslateBox);
// CONCATENATED MODULE: ./components/translate/index.js


function translate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function translate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function translate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import styles from "./style.scss";


var translate__ref = Object(preact_min["h"])(translate_box, null);

var App = function (_Component) {
  translate__inherits(App, _Component);

  function App() {
    translate__classCallCheck(this, App);

    return translate__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render(props) {
    return translate__ref;
  };

  return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js
var poly = __webpack_require__("m+Gh");






var _habitat = preact_habitat_es(App);

_habitat.render({
  selector: '[data-widget-host="habitat"]',
  clean: true
});

/***/ }),

/***/ "KM04":
/***/ (function(module, exports) {

var n,
    l,
    u,
    t,
    i,
    o,
    r,
    f = {},
    e = [],
    c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;function s(n, l) {
  for (var u in l) {
    n[u] = l[u];
  }return n;
}function a(n) {
  var l = n.parentNode;l && l.removeChild(n);
}function p(n, l, u) {
  var t,
      i = arguments,
      o = {};for (t in l) {
    "key" !== t && "ref" !== t && (o[t] = l[t]);
  }if (arguments.length > 3) for (u = [u], t = 3; t < arguments.length; t++) {
    u.push(i[t]);
  }if (null != u && (o.children = u), "function" == typeof n && null != n.defaultProps) for (t in n.defaultProps) {
    void 0 === o[t] && (o[t] = n.defaultProps[t]);
  }return h(n, o, l && l.key, l && l.ref);
}function h(l, u, t, i) {
  var o = { type: l, props: u, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __d: null, __c: null, constructor: void 0 };return n.vnode && n.vnode(o), o;
}function v(n) {
  return n.children;
}function y(n, l) {
  this.props = n, this.context = l;
}function d(n, l) {
  if (null == l) return n.__ ? d(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  }return "function" == typeof n.type ? d(n) : null;
}function m(n) {
  var l, u;if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) {
        n.__e = n.__c.base = u.__e;break;
      }
    }return m(n);
  }
}function x(l) {
  (!l.__d && (l.__d = !0) && 1 === u.push(l) || i !== n.debounceRendering) && ((i = n.debounceRendering) || t)(w);
}function w() {
  var n, l, t, i, o, r, f;for (u.sort(function (n, l) {
    return l.__v.__b - n.__v.__b;
  }); n = u.pop();) {
    n.__d && (t = void 0, i = void 0, r = (o = (l = n).__v).__e, (f = l.__P) && (t = [], i = N(f, o, s({}, o), l.__n, void 0 !== f.ownerSVGElement, null, t, null == r ? d(o) : r), T(t, o), i != r && m(o)));
  }
}function g(n, l, u, t, i, o, r, c, s) {
  var p,
      h,
      v,
      y,
      m,
      x,
      w,
      g = u && u.__k || e,
      _ = g.length;if (c == f && (c = null != o ? o[0] : _ ? d(u, 0) : null), p = 0, l.__k = k(l.__k, function (u) {
    if (null != u) {
      if (u.__ = l, u.__b = l.__b + 1, null === (v = g[p]) || v && u.key == v.key && u.type === v.type) g[p] = void 0;else for (h = 0; h < _; h++) {
        if ((v = g[h]) && u.key == v.key && u.type === v.type) {
          g[h] = void 0;break;
        }v = null;
      }if (y = N(n, u, v = v || f, t, i, o, r, c, s), (h = u.ref) && v.ref != h && (w || (w = []), v.ref && w.push(v.ref, null, u), w.push(h, u.__c || y, u)), null != y) {
        if (null == x && (x = y), null != u.__d) y = u.__d, u.__d = null;else if (o == v || y != c || null == y.parentNode) {
          n: if (null == c || c.parentNode !== n) n.appendChild(y);else {
            for (m = c, h = 0; (m = m.nextSibling) && h < _; h += 2) {
              if (m == y) break n;
            }n.insertBefore(y, c);
          }"option" == l.type && (n.value = "");
        }c = y.nextSibling, "function" == typeof l.type && (l.__d = y);
      }
    }return p++, u;
  }), l.__e = x, null != o && "function" != typeof l.type) for (p = o.length; p--;) {
    null != o[p] && a(o[p]);
  }for (p = _; p--;) {
    null != g[p] && z(g[p], g[p]);
  }if (w) for (p = 0; p < w.length; p++) {
    j(w[p], w[++p], w[++p]);
  }
}function k(n, l, u) {
  if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));else if (Array.isArray(n)) for (var t = 0; t < n.length; t++) {
    k(n[t], l, u);
  } else u.push(l ? l("string" == typeof n || "number" == typeof n ? h(null, n, null, null) : null != n.__e || null != n.__c ? h(n.type, n.props, n.key, null) : n) : n);return u;
}function _(n, l, u, t, i) {
  var o;for (o in u) {
    o in l || C(n, o, null, u[o], t);
  }for (o in l) {
    i && "function" != typeof l[o] || "value" === o || "checked" === o || u[o] === l[o] || C(n, o, l[o], u[o], t);
  }
}function b(n, l, u) {
  "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === c.test(l) ? u + "px" : null == u ? "" : u;
}function C(n, l, u, t, i) {
  var o, r, f, e, c;if (i ? "className" === l && (l = "class") : "class" === l && (l = "className"), "key" === l || "children" === l) ;else if ("style" === l) {
    if (o = n.style, "string" == typeof u) o.cssText = u;else {
      if ("string" == typeof t && (o.cssText = "", t = null), t) for (r in t) {
        u && r in u || b(o, r, "");
      }if (u) for (f in u) {
        t && u[f] === t[f] || b(o, f, u[f]);
      }
    }
  } else "o" === l[0] && "n" === l[1] ? (e = l !== (l = l.replace(/Capture$/, "")), c = l.toLowerCase(), l = (c in n ? c : l).slice(2), u ? (t || n.addEventListener(l, P, e), (n.l || (n.l = {}))[l] = u) : n.removeEventListener(l, P, e)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u ? n.removeAttribute(l) : n.setAttribute(l, u));
}function P(l) {
  this.l[l.type](n.event ? n.event(l) : l);
}function N(l, u, t, i, o, r, f, e, c) {
  var a,
      p,
      h,
      d,
      m,
      x,
      w,
      _,
      b,
      C,
      P = u.type;if (void 0 !== u.constructor) return null;(a = n.__b) && a(u);try {
    n: if ("function" == typeof P) {
      if (_ = u.props, b = (a = P.contextType) && i[a.__c], C = a ? b ? b.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in P && P.prototype.render ? u.__c = p = new P(_, C) : (u.__c = p = new y(_, C), p.constructor = P, p.render = A), b && b.sub(p), p.props = _, p.state || (p.state = {}), p.context = C, p.__n = i, h = p.__d = !0, p.__h = []), null == p.__s && (p.__s = p.state), null != P.getDerivedStateFromProps && (p.__s == p.state && (p.__s = s({}, p.__s)), s(p.__s, P.getDerivedStateFromProps(_, p.__s))), d = p.props, m = p.state, h) null == P.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);else {
        if (null == P.getDerivedStateFromProps && _ !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(_, C), !p.__e && null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(_, p.__s, C)) {
          for (p.props = _, p.state = p.__s, p.__d = !1, p.__v = u, u.__e = t.__e, u.__k = t.__k, p.__h.length && f.push(p), a = 0; a < u.__k.length; a++) {
            u.__k[a] && (u.__k[a].__ = u);
          }break n;
        }null != p.componentWillUpdate && p.componentWillUpdate(_, p.__s, C), null != p.componentDidUpdate && p.__h.push(function () {
          p.componentDidUpdate(d, m, x);
        });
      }p.context = C, p.props = _, p.state = p.__s, (a = n.__r) && a(u), p.__d = !1, p.__v = u, p.__P = l, a = p.render(p.props, p.state, p.context), u.__k = k(null != a && a.type == v && null == a.key ? a.props.children : a), null != p.getChildContext && (i = s(s({}, i), p.getChildContext())), h || null == p.getSnapshotBeforeUpdate || (x = p.getSnapshotBeforeUpdate(d, m)), g(l, u, t, i, o, r, f, e, c), p.base = u.__e, p.__h.length && f.push(p), w && (p.__E = p.__ = null), p.__e = null;
    } else u.__e = $(t.__e, u, t, i, o, r, f, c);(a = n.diffed) && a(u);
  } catch (l) {
    n.__e(l, u, t);
  }return u.__e;
}function T(l, u) {
  n.__c && n.__c(u, l), l.some(function (u) {
    try {
      l = u.__h, u.__h = [], l.some(function (n) {
        n.call(u);
      });
    } catch (l) {
      n.__e(l, u.__v);
    }
  });
}function $(n, l, u, t, i, o, r, c) {
  var s,
      a,
      p,
      h,
      v,
      y = u.props,
      d = l.props;if (i = "svg" === l.type || i, null == n && null != o) for (s = 0; s < o.length; s++) {
    if (null != (a = o[s]) && (null === l.type ? 3 === a.nodeType : a.localName === l.type)) {
      n = a, o[s] = null;break;
    }
  }if (null == n) {
    if (null === l.type) return document.createTextNode(d);n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type), o = null;
  }if (null === l.type) null != o && (o[o.indexOf(n)] = null), y !== d && n.data != d && (n.data = d);else if (l !== u) {
    if (null != o && (o = e.slice.call(n.childNodes)), p = (y = u.props || f).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
      if (y === f) for (y = {}, v = 0; v < n.attributes.length; v++) {
        y[n.attributes[v].name] = n.attributes[v].value;
      }(h || p) && (h && p && h.__html == p.__html || (n.innerHTML = h && h.__html || ""));
    }_(n, d, y, i, c), l.__k = l.props.children, h || g(n, l, u, t, "foreignObject" !== l.type && i, o, r, f, c), c || ("value" in d && void 0 !== d.value && d.value !== n.value && (n.value = null == d.value ? "" : d.value), "checked" in d && void 0 !== d.checked && d.checked !== n.checked && (n.checked = d.checked));
  }return n;
}function j(l, u, t) {
  try {
    "function" == typeof l ? l(u) : l.current = u;
  } catch (l) {
    n.__e(l, t);
  }
}function z(l, u, t) {
  var i, o, r;if (n.unmount && n.unmount(l), (i = l.ref) && (i.current && i.current !== l.__e || j(i, null, u)), t || "function" == typeof l.type || (t = null != (o = l.__e)), l.__e = l.__d = null, null != (i = l.__c)) {
    if (i.componentWillUnmount) try {
      i.componentWillUnmount();
    } catch (l) {
      n.__e(l, u);
    }i.base = i.__P = null;
  }if (i = l.__k) for (r = 0; r < i.length; r++) {
    i[r] && z(i[r], u, t);
  }null != o && a(o);
}function A(n, l, u) {
  return this.constructor(n, u);
}function D(l, u, t) {
  var i, r, c;n.__ && n.__(l, u), r = (i = t === o) ? null : t && t.__k || u.__k, l = p(v, null, [l]), c = [], N(u, (i ? u : t || u).__k = l, r || f, f, void 0 !== u.ownerSVGElement, t && !i ? [t] : r ? null : e.slice.call(u.childNodes), c, t || f, i), T(c, l);
}n = { __e: function __e(n, l) {
    for (var u, t; l = l.__;) {
      if ((u = l.__c) && !u.__) try {
        if (u.constructor && null != u.constructor.getDerivedStateFromError && (t = !0, u.setState(u.constructor.getDerivedStateFromError(n))), null != u.componentDidCatch && (t = !0, u.componentDidCatch(n)), t) return x(u.__E = u);
      } catch (l) {
        n = l;
      }
    }throw n;
  } }, l = function l(n) {
  return null != n && void 0 === n.constructor;
}, y.prototype.setState = function (n, l) {
  var u;u = this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(u, this.props)), n && s(u, n), null != n && this.__v && (this.__e = !1, l && this.__h.push(l), x(this));
}, y.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), x(this));
}, y.prototype.render = v, u = [], t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = f, r = 0, exports.render = D, exports.hydrate = function (n, l) {
  D(n, l, o);
}, exports.createElement = p, exports.h = p, exports.Fragment = v, exports.createRef = function () {
  return {};
}, exports.isValidElement = l, exports.Component = y, exports.cloneElement = function (n, l) {
  return l = s(s({}, n.props), l), arguments.length > 2 && (l.children = e.slice.call(arguments, 2)), h(n.type, l, l.key || n.key, l.ref || n.ref);
}, exports.createContext = function (n) {
  var l = {},
      u = { __c: "__cC" + r++, __: n, Consumer: function Consumer(n, l) {
      return n.children(l);
    }, Provider: function Provider(n) {
      var t,
          i = this;return this.getChildContext || (t = [], this.getChildContext = function () {
        return l[u.__c] = i, l;
      }, this.shouldComponentUpdate = function (l) {
        n.value !== l.value && t.some(function (n) {
          n.context = l.value, x(n);
        });
      }, this.sub = function (n) {
        t.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
          t.splice(t.indexOf(n), 1), l && l.call(n);
        };
      }), n.children;
    } };return u.Consumer.contextType = u, u;
}, exports.toChildArray = k, exports._e = z, exports.options = n;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "VS7n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = window.fetch || (window.fetch = __webpack_require__("6dPT").default || __webpack_require__("6dPT"));

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "m+Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

if (!global.Promise) global.Promise = __webpack_require__("BtxX");
if (!global.fetch) global.fetch = __webpack_require__("yDyG");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "mX86":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".main-translate-box__2dPil{display:block}.main-translate-box__2dPil .translate-box__1dYO_{display:block;width:100%;padding:0}.main-translate-box__2dPil .translate-box__1dYO_:first-child{margin-bottom:20px}.main-translate-box__2dPil .translate-box__lang__3I9Ri{margin:0!important;color:#0059cd;font-size:1em;text-align:center;border-bottom:1px solid #dbdbdb;background:#dbdbdb;padding:5px 12px;line-height:2}.main-translate-box__2dPil .translate-box__lang__3I9Ri span{color:#7a7a7a}.main-translate-box__2dPil .translate-box__lang__3I9Ri span:before{content:\"|\";padding:0 10px}.main-translate-box__2dPil .translate-box__input-box__3HIq4{background-color:#fff;border-radius:1rem;-webkit-box-shadow:0 .25rem 1rem rgba(48,55,66,.15);box-shadow:0 .25rem 1rem rgba(48,55,66,.15);height:250px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.main-translate-box__2dPil .translate-box__input__3KlLV{-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative;overflow:hidden;border-radius:1rem}.main-translate-box__2dPil .translate-box__input__3KlLV textarea{margin:0;width:calc(100% - 40px);height:calc(100% - 30px);border:0;padding:20px;font-size:1.5em;color:#0059cd;resize:none}.main-translate-box__2dPil .translate-box__input__3KlLV textarea.source__2ekaT{color:#0a0a0a;cursor:text}.main-translate-box__2dPil .translate-box__input__3KlLV textarea:focus{outline:none}.main-translate-box__2dPil .translate-box__input__3KlLV textarea::-webkit-input-placeholder{color:#7a7a7a;font-size:.8em}.main-translate-box__2dPil .translate-box__input__3KlLV textarea:-moz-placeholder,.main-translate-box__2dPil .translate-box__input__3KlLV textarea::-moz-placeholder{color:#7a7a7a;font-size:.8em}.main-translate-box__2dPil .translate-box__input__3KlLV textarea:-ms-input-placeholder,.main-translate-box__2dPil .translate-box__input__3KlLV textarea::-ms-input-placeholder{color:#7a7a7a;font-size:.8em}.main-translate-box__2dPil .translate-box__input__3KlLV textarea::placeholder{color:#7a7a7a;font-size:.8em}.main-translate-box__2dPil .translate-box__input__3KlLV button{position:absolute;right:calc(50% - 30px);bottom:-25px;top:auto;padding:0 20px 15px;height:60px;width:60px;border-radius:50%;text-align:left;background:#7a7a7a;border:0;-webkit-transition:all .3s ease;transition:all .3s ease;cursor:pointer}.main-translate-box__2dPil .translate-box__input__3KlLV button:focus{outline:none}.main-translate-box__2dPil .translate-box__input__3KlLV button svg{fill:#fff;width:100%;height:100%;margin:0}.main-translate-box__2dPil .translate-box__input__3KlLV button.active__23SD9{cursor:pointer;background:#0059cd}.main-translate-box__2dPil .translate-box__input__3KlLV button.active__23SD9:hover{-webkit-transform:scale(1.2);-ms-transform:scale(1.2);transform:scale(1.2)}.main-translate-box__2dPil .translate-box__input__3KlLV button.active__23SD9:focus{-webkit-transform:scale(4.5);-ms-transform:scale(4.5);transform:scale(4.5)}.main-translate-box__2dPil .translate-box__input__3KlLV button.clear___4L94{position:absolute;top:0;right:0;background:transparent;width:40px;height:40px;padding:10px;text-align:center;cursor:pointer}.main-translate-box__2dPil .translate-box__input__3KlLV button.clear___4L94 svg{width:100%;height:100%;fill:#7a7a7a}.main-translate-box__2dPil .translate-box__panel__2sHob{border-radius:0 0 1rem 1rem;height:0}.main-translate-box__2dPil .translate-box__panel__2sHob ul{list-style:none;padding:5px 10px;margin:0;display:block}.main-translate-box__2dPil .translate-box__panel__2sHob ul li{display:inline-block;color:#4a4a4a;padding:0 5px}.main-translate-box__2dPil .translate-box__panel__2sHob ul li:not(:last-child){border-right:2px solid #fafafa}.main-translate-box__2dPil .translate-box__panel__2sHob ul li button{background:initial;border:0;color:#0059cd;font-size:1rem;opacity:.6}.main-translate-box__2dPil .translate-box__panel__2sHob ul li button.active__23SD9{opacity:1;cursor:pointer}.main-translate-box__2dPil .translate-box__panel__2sHob ul li button:focus{outline:none}.main-translate-box__2dPil .translate-box__panel__2sHob ul li button svg{height:20px;width:20px;margin-bottom:-4px;padding:2px}@media only screen and (min-width:46.875em){.main-translate-box__2dPil .translate-box__1dYO_{display:inline-block;width:calc(50% - 10px)}.main-translate-box__2dPil .translate-box__1dYO_:first-child{margin-right:20px;margin-bottom:0}.main-translate-box__2dPil .translate-box__lang__3I9Ri{text-align:left}.main-translate-box__2dPil .translate-box__input__3KlLV button{right:-30px;top:40%;padding:0 15px 0 8px}.main-translate-box__2dPil .translate-box__input__3KlLV button svg{fill:#fff;width:50%;height:50%;margin:0}}@media only screen and (min-width:65.625em){.main-translate-box__2dPil .translate-box__input__3KlLV button{right:-30px;top:40%}}.related-result__1iusy{margin-top:2rem}.related-result__1iusy table{min-width:100%;border-collapse:collapse;border-spacing:0;border:none}.related-result__1iusy table .nobd__2AxuK{background:transparent;border:none}.related-result__1iusy table .category__27K-V{background:#eaf4ff;text-transform:capitalize}.related-result__1iusy table .category__27K-V h4{margin:0}.related-result__1iusy table td,.related-result__1iusy table th{padding:.25em .5em}.related-result__1iusy table td{text-align:left;border:1px solid #dbdbdb}.related-result__1iusy table td:first-child{vertical-align:top}.related-result__1iusy table p{padding:.2em 0;margin:0}.related-result__1iusy a{color:#333}.related-result__1iusy a svg{color:#333;width:20px;height:20px}.text-grey__1GOa9{color:#7a7a7a}", "", {"version":3,"sources":["/Users/kittipongint/projects/wordyguru-translate-widget/src/components/translate-box/style.module.scss"],"names":[],"mappings":"AAsDA,2BACE,aAAc,CADhB,iDAII,cACA,WACA,SAAU,CANd,6DASM,kBAAmB,CATzB,uDAaM,mBACA,cACA,cACA,kBACA,gCACA,mBACA,iBACA,aAAc,CApBpB,4DAuBQ,aAnEc,CA4CtB,mEAyBU,YACA,cAAe,CA1BzB,4DA+BM,sBACA,mBAnCJ,oDAAA,4CAqCI,aACA,oBAAA,oBAAA,aACA,4BAAA,6BAAA,0BAAA,qBAAsB,CApC5B,wDAuCM,mBAAA,WAAA,OACA,kBACA,gBACA,kBAAmB,CA1CzB,iEA4CQ,SACA,wBACA,yBACA,SACA,aACA,gBACA,cACA,WAAY,CAnDpB,+EAqDU,cACA,WAAY,CAtDtB,uEAyDU,YAAa,CAzDvB,4FA4DU,cACA,cAAgB,CA7D1B,qKAwEU,cACA,cAAgB,CAzE1B,+KAkFU,cACA,cAAgB,CAnF1B,8EAkFU,cACA,cAAgB,CAnF1B,+DAuFQ,kBACA,uBACA,aACA,SACA,oBAEA,YACA,WACA,kBACA,gBACA,mBACA,SACA,gCAAA,wBACA,cAAe,CApGvB,qEAsGU,YAAa,CAtGvB,mEAyGU,UACA,WACA,YACA,QAAS,CA5GnB,6EA+GU,eACA,kBAtKa,CAsDvB,mFAmHY,6BACA,yBACA,oBAAqB,CArHjC,mFAwHY,6BACA,yBACA,oBAAqB,CA1HjC,4EA+HU,kBACA,MACA,QACA,uBACA,WACA,YACA,aACA,kBACA,cAAe,CAvIzB,gFAyIY,WACA,YACA,YAvLU,CA4CtB,wDAkJM,4BACA,QAAS,CAnJf,2DAqJQ,gBACA,iBACA,SACA,aAAc,CAxJtB,8DA0JU,qBACA,cACA,aAAc,CA5JxB,+EA8JY,8BAvMmB,CAyC/B,qEAkKY,mBACA,SACA,cACA,eACA,UAAY,CAtKxB,mFAwKc,UACA,cAAe,CAzK7B,2EA4Kc,YAAa,CA5K3B,yEA+Kc,YACA,WACA,mBACA,WAAY,CACb,4CASX,iDAEI,qBACA,sBAAuB,CAH3B,6DAMM,kBACA,eAAkB,CAPxB,uDAWM,eAAgB,CAXtB,+DAmBQ,YACA,QACA,oBAAqB,CArB7B,mEAuBU,UACA,UACA,WACA,QAAS,CACV,CAMX,4CACE,+DAUQ,YACA,OAAQ,CACT,CAMT,uBACE,eAAgB,CADlB,6BAGI,eACA,yBACA,iBACA,WAAY,CANhB,0CASM,uBACA,WAAY,CAVlB,8CAaM,mBACA,yBAA0B,CAdhC,iDAgBQ,QAAS,CAhBjB,gEAsBM,kBAAqB,CAtB3B,gCAyBM,gBACA,wBAAyB,CA1B/B,4CA4BQ,kBAAmB,CA5B3B,+BAgCM,eACA,QAAS,CAjCf,yBAqCI,UAAW,CArCf,6BAuCM,WACA,WACA,WAAY,CACb,kBAKH,aA3UoB,CA4UrB","file":"style.module.scss","sourcesContent":["$primary-color: #0059cd !default;\n$primary-slave-color: #0066d5 !default;\n$secondary-color: #2f82d9 !default;\n\n$black: hsl(0, 0%, 4%) !default;\n$black-bis: hsl(0, 0%, 7%) !default;\n$black-ter: hsl(0, 0%, 14%) !default;\n\n$grey-darker: hsl(0, 0%, 21%) !default;\n$grey-dark: hsl(0, 0%, 29%) !default;\n$grey: hsl(0, 0%, 48%) !default;\n$grey-light: hsl(0, 0%, 71%) !default;\n$grey-lighter: hsl(0, 0%, 86%) !default;\n$grey-lightest: hsl(0, 0%, 98%) !default;\n\n$white-ter: hsl(0, 0%, 96%) !default;\n$white-bis: hsl(0, 0%, 98%) !default;\n$white: hsl(0, 0%, 100%) !default;\n\n$orange: hsl(14, 100%, 53%) !default;\n$yellow: hsl(48, 100%, 67%) !default;\n$green: hsl(141, 71%, 48%) !default;\n$turquoise: hsl(171, 100%, 41%) !default;\n$cyan: hsl(204, 86%, 53%) !default;\n$blue: hsl(217, 71%, 53%) !default;\n$purple: hsl(271, 100%, 71%) !default;\n$red: hsl(348, 100%, 61%) !default;\n\n@mixin is-circle {\n  border-radius: 50%;\n}\n\n@mixin has-shadow-right {\n  -webkit-box-shadow: 3px 0px 7px 0px rgba(0, 0, 0, 0.25);\n  -moz-box-shadow: 3px 0px 7px 0px rgba(0, 0, 0, 0.25);\n  box-shadow: 3px 0px 7px 0px rgba(0, 0, 0, 0.25);\n}\n\n@mixin has-shadow-down {\n  -webkit-box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.25);\n  -moz-box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.25);\n  box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.25);\n}\n\n@mixin has-shadow-up {\n  -webkit-box-shadow: 3px 0px 10px 1px rgba(0, 0, 0, 0.25);\n  -moz-box-shadow: 3px 0px 10px 1px rgba(0, 0, 0, 0.25);\n  box-shadow: 3px 0px 10px 1px rgba(0, 0, 0, 0.25);\n}\n\n@mixin shadow {\n  box-shadow: 0 0.25rem 1rem rgba(48, 55, 66, 0.15);\n}\n\n.main-translate-box {\n  display: block;\n\n  .translate-box {\n    display: block;\n    width: 100%;\n    padding: 0;\n\n    &:first-child {\n      margin-bottom: 20px;\n    }\n\n    &__lang {\n      margin: 0 !important;\n      color: $primary-color;\n      font-size: 1em;\n      text-align: center;\n      border-bottom: 1px solid $grey-lighter;\n      background: $grey-lighter;\n      padding: 5px 12px;\n      line-height: 2;\n\n      span {\n        color: $grey;\n        &::before {\n          content: \"|\";\n          padding: 0 10px;\n        }\n      }\n    }\n    &__input-box {\n      background-color: $white;\n      border-radius: 1rem;\n      @include shadow;\n      height: 250px;\n      display: flex;\n      flex-direction: column;\n    }\n    &__input {\n      flex: 1;\n      position: relative;\n      overflow: hidden;\n      border-radius: 1rem;\n      textarea {\n        margin: 0;\n        width: calc(100% - 40px);\n        height: calc(100% - 30px);\n        border: 0;\n        padding: 20px;\n        font-size: 1.5em;\n        color: $primary-color;\n        resize: none;\n        &.source {\n          color: $black;\n          cursor: text;\n        }\n        &:focus {\n          outline: none;\n        }\n        &::-webkit-input-placeholder {\n          color: $grey;\n          font-size: 0.8em;\n        }\n\n        &:-moz-placeholder {\n          /* Firefox 18- */\n          color: $grey;\n          font-size: 0.8em;\n        }\n\n        &::-moz-placeholder {\n          /* Firefox 19+ */\n          color: $grey;\n          font-size: 0.8em;\n        }\n\n        &:-ms-input-placeholder {\n          color: $grey;\n          font-size: 0.8em;\n        }\n\n        &::placeholder {\n          color: $grey;\n          font-size: 0.8em;\n        }\n      }\n      button {\n        position: absolute;\n        right: calc(50% - 30px);\n        bottom: -25px;\n        top: initial;\n        padding: 0 20px 15px 20px;\n\n        height: 60px;\n        width: 60px;\n        border-radius: 50%;\n        text-align: left;\n        background: $grey;\n        border: 0;\n        transition: all 0.3s ease;\n        cursor: pointer;\n        &:focus {\n          outline: none;\n        }\n        svg {\n          fill: #fff;\n          width: 100%;\n          height: 100%;\n          margin: 0;\n        }\n        &.active {\n          cursor: pointer;\n          background: $primary-color;\n\n          &:hover {\n            -webkit-transform: scale(1.2);\n            -ms-transform: scale(1.2);\n            transform: scale(1.2);\n          }\n          &:focus {\n            -webkit-transform: scale(4.5);\n            -ms-transform: scale(4.5);\n            transform: scale(4.5);\n          }\n        }\n\n        &.clear {\n          position: absolute;\n          top: 0;\n          right: 0;\n          background: transparent;\n          width: 40px;\n          height: 40px;\n          padding: 10px;\n          text-align: center;\n          cursor: pointer;\n          svg {\n            width: 100%;\n            height: 100%;\n            fill: $grey;\n          }\n        }\n      }\n    }\n    &__panel {\n      // border: 1px solid $grey-lightest;\n      border-radius: 0 0 1rem 1rem;\n      height: 0;\n      ul {\n        list-style: none;\n        padding: 5px 10px;\n        margin: 0;\n        display: block;\n        li {\n          display: inline-block;\n          color: $grey-dark;\n          padding: 0 5px;\n          &:not(:last-child) {\n            border-right: 2px solid $grey-lightest;\n          }\n\n          button {\n            background: initial;\n            border: 0;\n            color: $primary-color;\n            font-size: 1rem;\n            opacity: 0.6;\n            &.active {\n              opacity: 1;\n              cursor: pointer;\n            }\n            &:focus {\n              outline: none;\n            }\n            svg {\n              height: 20px;\n              width: 20px;\n              margin-bottom: -4px;\n              padding: 2px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-width: 46.875em) {\n  .main-translate-box {\n    .translate-box {\n      display: inline-block;\n      width: calc(50% - 10px);\n\n      &:first-child {\n        margin-right: 20px;\n        margin-bottom: 0px;\n      }\n\n      &__lang {\n        text-align: left;\n      }\n      &__input-box {\n      }\n      &__input {\n        textarea {\n        }\n        button {\n          right: -30px;\n          top: 40%;\n          padding: 0 15px 0 8px;\n          svg {\n            fill: #fff;\n            width: 50%;\n            height: 50%;\n            margin: 0;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 65.625em) {\n  .main-translate-box {\n    .translate-box {\n      &__lang {\n      }\n      &__input-box {\n      }\n      &__input {\n        textarea {\n        }\n        button {\n          right: -30px;\n          top: 40%;\n        }\n      }\n    }\n  }\n}\n\n.related-result {\n  margin-top: 2rem;\n  table {\n    min-width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    border: none;\n\n    .nobd {\n      background: transparent;\n      border: none;\n    }\n    .category {\n      background: #eaf4ff;\n      text-transform: capitalize;\n      h4 {\n        margin: 0;\n      }\n    }\n\n    th,\n    td {\n      padding: 0.25em 0.5em;\n    }\n    td {\n      text-align: left;\n      border: 1px solid #dbdbdb;\n      &:first-child {\n        vertical-align: top;\n      }\n    }\n    p {\n      padding: 0.2em 0;\n      margin: 0;\n    }\n  }\n  a {\n    color: #333;\n    svg {\n      color: #333;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.text-grey {\n  color: $grey;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"main-translate-box": "main-translate-box__2dPil",
	"translate-box": "translate-box__1dYO_",
	"translate-box__lang": "translate-box__lang__3I9Ri",
	"translate-box__input-box": "translate-box__input-box__3HIq4",
	"translate-box__input": "translate-box__input__3KlLV",
	"source": "source__2ekaT",
	"active": "active__23SD9",
	"clear": "clear___4L94",
	"translate-box__panel": "translate-box__panel__2sHob",
	"related-result": "related-result__1iusy",
	"nobd": "nobd__2AxuK",
	"category": "category__27K-V",
	"text-grey": "text-grey__1GOa9"
};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "yDyG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = window.fetch || (window.fetch = __webpack_require__("QAmr").default || __webpack_require__("QAmr"));

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js